import type { AdminSectionId } from "../adminData";
import { adminSectionLabels } from "../adminData";
import Button from "../../ui/Button/Button";

type AdminSectionNavProps = {
  activeSection: AdminSectionId;
  onSelect: (section: AdminSectionId) => void;
};

const sections: AdminSectionId[] = ["users", "gigs", "reviews", "feedback", "issues", "payments", "notifications", "audit"];

const AdminSectionNav = ({ activeSection, onSelect }: AdminSectionNavProps) => {
  return (
    <div className="overflow-x-auto rounded-[1.5rem] border border-myteengig-border bg-white p-3 shadow-sm">
      <div className="flex min-w-max items-center gap-2">
        {sections.map((section) => (
          <Button
            key={section}
            type="button"
            variant={activeSection === section ? "primary" : "outline"}
            className="shrink-0"
            onClick={() => onSelect(section)}
          >
            {adminSectionLabels[section]}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default AdminSectionNav;
